import "../packs/combined_foundation"
import api from "./api"
import SharePrompt from "./share-prompt"

// Used for both Create and Edit
// TODO: rename to CreateOrEditModal or better name
window.slideshare_object.Clipboards = {}
const CB = window.slideshare_object.Clipboards
let status = {
    created: "created",
    updated: "updated",
    cancelled: "cancelled",
    failed: "failed",
  },
  /* Events */
  events = {
    clipboardEdited: "clipboard:edited",
    clipboardCreated: "clipboard:created",
    beforeModalOpen: "open.fndtn.reveal",
    afterModalOpen: "opened.fndtn.reveal",
    afterModalClose: "closed.fndtn.reveal",
  },
  /* Cached DOM selectors */
  selectors = {
    cancel: ".j-cancel-button",
    submit: ".j-submit-button",
    form: "form",
    firstClipMessage: ".first-clip-message",
    modalTitle: ".modal-title",
    private: ".j-privacy-input",
    privacyDescription: "#privacy-switch-description",
    title: ".j-title-input",
    titleError: ".j-title-error",
    titleWrapper: ".j-title-wrapper",
    description: ".j-description-input",
    descriptionError: ".j-description-error",
    descriptionWrapper: ".j-description-wrapper",
    i18n: ".j-i18n-edit-clipboard-modal",
  },
  classes = {
    firstClipModal: "first-clip-modal",
    hide: "hide",
  },
  /* changed fields after each edit operation */
  changedFields = {
    title: false,
    description: false,
  },
  FOCUS_SELECTOR =
    'a[href], input:not([disabled],[type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), *[tabindex], *[contenteditable]',
  FORM_TYPE_EDIT = "edit",
  FORM_TYPE_CREATE = "create",
  DEFAULT_CONFIG = {
    onClose: $.noop,
    clipboard: {},
  }

/**
 * Creates a new edit dialog
 * @constructor
 * @param {object} config A config object
 * @param {object} config.el The root element of the modal
 * @param {object} config.clipboard The actively selected clipboard
 * @param {function} config.onClose A function for when the modal closes
 */
function EditModal(config) {
  this.config = $.extend({}, DEFAULT_CONFIG, config)
  this.clipboard = this.config.clipboard
  this.onClose = this.config.onClose
  this.onSave = this.config.onSave
  this.status = status.cancelled
  this.changedFields = changedFields

  this._init()
}

/**
 * Initializes the edit dialog
 * @method
 * @private
 */
EditModal.prototype._init = function () {
  let $focusEl

  this.$el = $(this.config.el)

  if (!this.$el.length) {
    throw new Error("Error initializing EditModal")
  }

  this.$form = this.$el.find(selectors.form)
  this.$firstClipMessage = this.$el.find(selectors.firstClipMessage)
  this.$modalTitle = this.$el.find(selectors.modalTitle)
  this.$private = this.$form.find(selectors.private)
  this.$privacyDescription = this.$form.find(selectors.privacyDescription)
  this.$title = this.$form.find(selectors.title)
  this.$description = this.$form.find(selectors.description)
  this.$trigger = $(document.activeElement)
  this.i18n = JSON.parse($(selectors.i18n).val())

  $focusEl = this.config.focus === this.config.el ? this.$el : this.$el.find(this.config.focus)

  this.$focusEl = $focusEl.length ? $focusEl : this.$title
  this._attachEventListeners()
}

/**
 * Adds event handlers required by edit dialog
 * @method _attachEventListeners
 * @private
 */
EditModal.prototype._attachEventListeners = function () {
  if (this.config.type.toLowerCase() === FORM_TYPE_EDIT) {
    this.$el.on("click", selectors.submit, this._editClipboard.bind(this))
  } else {
    this.$el.on("click", selectors.submit, this._createClipboard.bind(this))
  }

  this.$el.on("click", selectors.cancel, this.close.bind(this))
  this.$el.on("keyup", selectors.title, this._clearTitleErrors.bind(this))
  this.$el.on("keyup", selectors.description, this._clearDescriptionErrors.bind(this))
  this.$el.on("change", selectors.private, this._setPrivacyDescription.bind(this))
  this.$el.on("keydown", this._handleTab.bind(this))
  $(document).on("focusin.edit_clipboard_modal", this._handleFocusTrap.bind(this))

  this.$el.on(events.beforeModalOpen, this._onOpen.bind(this))
  this.$el.on(events.afterModalOpen, this._onOpened.bind(this))
  this.$el.on(events.afterModalClose, this._onClosed.bind(this))
}

/**
 * Removes event handlers added to edit dialog
 * @method _detachEventListeners
 * @private
 */
EditModal.prototype._detachEventListeners = function () {
  this.$el.off()
  $(document).off("focusin.edit_clipboard_modal")
}

/**
 * Resets the create clipboard form to its original state.
 * @public
 */
EditModal.prototype.reset = function () {
  this.$form[0].reset()
  this._resetChangedFields()
  this.$el.removeClass(classes.firstClipModal)
  this.$firstClipMessage.addClass(classes.hide)
}

/**
 * Sets modal title based on form type.
 * @private
 */
EditModal.prototype._setModalTitle = function () {
  let headerTitle = this.config.type === FORM_TYPE_CREATE ? this.i18n.formTitleCreate : this.i18n.formTitleEdit
  this.$modalTitle.text(headerTitle)
}

/**
 * Pre-fills the edit clipboard form based on active clipboard selection.
 * @private
 */
EditModal.prototype._setFormContent = function () {
  // NOTE: Create modal isn't bound to a clipboard
  if (this.clipboard && this.config.type.toLowerCase() === FORM_TYPE_EDIT) {
    this.$title.val(this.clipboard.title)
    this.$description.val(this.clipboard.description)
    this.$private.attr("checked", !!this.clipboard.private)
  }
}

/**
 * Updates privacy description when clipboard privacy check box is toggled.
 * @param {Boolean} isInitCall indicates if first time this value is set on the modal, to prevent aria-live region to be set and read
 * @private
 */
EditModal.prototype._setPrivacyDescription = function (isInitCall) {
  let message = this.$private.is(":checked") ? this.i18n.privacyEnabled : this.i18n.privacyDisabled
  this.$privacyDescription.text(message)

  if (!isInitCall) {
    this.$privacyDescription.attr("role", "status")
  }
}

/**
 * Shows the first time clipping message
 * @private
 */
EditModal.prototype._setFirstClipMessage = function () {
  if (this.config.showFirstClipMessage) {
    this.$el.addClass(classes.firstClipModal)
    this.$firstClipMessage.removeClass(classes.hide)
  }
}

/**
 * Displays any validation errors
 * @method _showErrors
 * @param {Object} xhr response from edit clipboard api
 * @private
 */
EditModal.prototype._showErrors = function (xhr) {
  let errors = (xhr.responseJSON || {}).errors || {}

  if (errors.title) {
    this._setTitleErrors(errors.title[0])
  }

  if (errors.description) {
    this._setDescriptionErrors(errors.description[0])
  }
}

/**
 * Sets or clears any title validation errors
 * @private
 *
 * @param {String} titleError
 */
EditModal.prototype._setTitleErrors = function (titleError) {
  let $titleError = this.$el.find(selectors.titleError),
    $titleWrapper = this.$el.find(selectors.titleWrapper),
    $titleInput = this.$el.find(selectors.title)
  this._setErrors($titleError, $titleInput, $titleWrapper, titleError, `Name input error: ${titleError}`)
}

/**
 * Sets or clears any description validation errors
 * @private
 *
 * @param {String} descriptionError
 */
EditModal.prototype._setDescriptionErrors = function (descriptionError) {
  let $descriptionError = this.$el.find(selectors.descriptionError),
    $descriptionWrapper = this.$el.find(selectors.descriptionWrapper),
    $descriptionInput = this.$el.find(selectors.description)
  this._setErrors(
    $descriptionError,
    $descriptionInput,
    $descriptionWrapper,
    descriptionError,
    `Description input error: ${descriptionError}`
  )
}

/**
 * Sets or clears any validation errors
 * @private
 *
 * @param {Object} $elError
 * @param {Object} $elInput
 * @param {Object} $elWrapper
 * @param {String} errorMessage
 * @param {String} ariaLabel
 */
EditModal.prototype._setErrors = function ($elError, $elInput, $elWrapper, errorMessage, ariaLabel) {
  let hasError = Boolean(errorMessage)
  const customLabel = hasError ? ariaLabel ?? errorMessage : ""

  $elError.text(errorMessage || "")
  $elError.attr("aria-label", customLabel)
  if (hasError) {
    $elError.attr("role", "status")
  } else {
    $elError.removeAttr("role")
  }
  $elError.toggleClass("hide", !hasError)
  $elWrapper.toggleClass("error", hasError)
  $elInput.attr("aria-invalid", hasError.toString())
}

/**
 * Clears title errors
 * @private
 *
 */
EditModal.prototype._clearTitleErrors = function () {
  this._setTitleErrors()
}

/**
 * Clears description errors
 * @private
 *
 */
EditModal.prototype._clearDescriptionErrors = function () {
  this._setDescriptionErrors()
}

/**
 * Callback triggered before edit modal opens
 * @method _onOpen
 * @private
 */
EditModal.prototype._onOpen = function () {
  this._setFirstClipMessage()
  this._setModalTitle()
  this._setFormContent()
  this._setPrivacyDescription(true)
}

/**
 * Callback triggered after edit modal is open
 * @method _onOpened
 * @private
 */
EditModal.prototype._onOpened = function () {
  this.$focusEl.focus()
}

/**
 * Callback triggered after edit modal is closed
 * @method _onClosed
 * @private
 */
EditModal.prototype._onClosed = function () {
  this._detachEventListeners()
  this.reset()
  this.onClose(this.status, this.response)
  this.$trigger.focus()
}

/**
 * Event Handler after each edit operation
 *
 * @private
 */
EditModal.prototype._onClipboadChange = function () {
  if (this.changedFields.title || this.changedFields.description) {
    const sharePrompt = new SharePrompt()
    sharePrompt.show()
  }
}

/**
 * Callback triggered when user confirms edit clipboard action
 * @method _onSubmit
 * @private
 */
EditModal.prototype._editClipboard = function (e) {
  e.preventDefault()
  this._determineChangedFields()

  api
    .editClipboard(this.clipboard.id, {
      title: this.$title.val(),
      description: this.$description.val(),
      private: this.$private.is(":checked"),
    })
    .then(
      function (response) {
        // Trigger event to track clipboard edited
        $(document).trigger(events.clipboardEdited, {
          newClipboard: response.clipboard,
          oldClipboard: this.clipboard,
        })

        this.status = status.updated
        this.response = response
        this.close()
        this._onClipboadChange()
      }.bind(this),
      function (xhr) {
        this._showErrors(xhr)
        this.status = status.failed
      }.bind(this)
    )
}

/**
 * Determines Clipboard fields which changed after edit operation
 * @private
 */
EditModal.prototype._determineChangedFields = function () {
  let clipboard = this.clipboard,
    newTitle = this.$title.val(),
    newDescription = this.$description.val(),
    newPrivacy = this.$private.is(":checked")

  $.extend(this.changedFields, {
    title: newTitle !== this.clipboard.title,
    description: newDescription !== this.clipboard.description,
    privacy: newPrivacy !== this.clipboard.private,
  })
}

/**
 * Resets changed fields to false
 * @private
 */
EditModal.prototype._resetChangedFields = function () {
  this.changedFields = changedFields
}

/**
 * Callback triggered when user confirms edit clipboard action
 * @method _onSubmit
 * @private
 */
EditModal.prototype._createClipboard = function (e) {
  e.preventDefault()

  api
    .createClipboard({
      title: this.$title.val(),
      description: this.$description.val(),
      private: this.$private.is(":checked"),
    })
    .then(
      function (response) {
        //Trigger event to track clipboard created
        $(document).trigger(events.clipboardCreated, response)

        this.status = status.created
        this.response = response
        this.close()
      }.bind(this),
      function (xhr) {
        this._showErrors(xhr)
        this.status = status.failed
      }.bind(this)
    )
}

/**
 * Opens the edit modal.
 * @method open
 * @public
 */
EditModal.prototype.open = function () {
  this.status = status.cancelled
  this.response = null
  this.$el.foundation("reveal", "open").attr("tabindex", -1)
}

/**
 * Closes the edit modal.
 * @method close
 * @public
 */
EditModal.prototype.close = function () {
  this.$el.foundation("reveal", "close")
}

/**
 * Determines whether the user has backwards tabbed.
 * @method _handleTab
 * @private
 */
EditModal.prototype._handleTab = function (e) {
  this.isShiftTab = e.which === 9 && e.shiftKey
}

/**
 * Keeps keyboard focus within the dialog for accessibility.
 * @method _handleFocusTrap
 * @private
 */
EditModal.prototype._handleFocusTrap = function (e) {
  let $focusEl

  if (!$(e.target).closest(this.$el).length) {
    $focusEl = this.$el.find(FOCUS_SELECTOR).filter(":visible")
    $focusEl[this.isShiftTab ? "last" : "first"]().focus()
    this.isShiftTab = false
  }
}

export default EditModal
